module.exports = "/static/assets/fecad7da66ad4cdf1942253998bdc4bc.png";